import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class WindowService {
  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private cookieService: CookieService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    console.log('isBrowser', this.isBrowser);
  }

  alert(message: string): void {
    if (this.isBrowser) {
      alert(message);
    }
  }

  confirm(message: string): boolean {
    if (this.isBrowser) {
      return window.confirm(message);
    }
    return false;
  }


  setStorage(key: string, value: string): void {
    if (this.isBrowser) {
      // localStorage.setItem(key, value);
      this.cookieService.set(key,
        value,
        1,
        '/',
        // 'bzhyun.cn'
      );
    }
  }

  getStorage(key: string): string | null {
    if (this.isBrowser) {
      // return localStorage.getItem(key);
      return this.cookieService.get(key);
    }
    return null;
  }

  removeStorage(key: string): void {
    if (this.isBrowser) {
      // localStorage.removeItem(key);
      this.cookieService.deleteAll('/');
    }
  }

  clearStorage(): void {
    if (this.isBrowser) {
      // localStorage.clear();
      this.cookieService.deleteAll('/');
    }
  }
}
